import { createContext } from 'react';

const StudioContext = createContext('StudioContext');

export default StudioContext;